function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as s } from "./index.es33.js";
import { clsx as o } from "./index.es105.js";
import { Typography as f } from "./index.es35.js";
import { palette as p } from "./index.es36.js";
import { Icon as c } from "./index.es7.js";
import { checkboxSelectors as t } from "./index.es141.js";
import e from "./index.es142.js";
var z = function z(_ref) {
  var n = _ref.children,
    m = _ref.name,
    r = _ref.onChange,
    d = _ref.isValue,
    _ref$isDisabled = _ref.isDisabled,
    h = _ref$isDisabled === void 0 ? !1 : _ref$isDisabled,
    a = _ref.isIndeterminate,
    i = _ref.isSkipFocus,
    _ref$isExpandedClickA = _ref.isExpandedClickArea,
    x = _ref$isExpandedClickA === void 0 ? !1 : _ref$isExpandedClickA,
    b = _ref.kind,
    k = _ref.isOnTop;
  var y = function y(l) {
    r && r(l.target.checked);
  };
  return s.jsxs("label", {
    className: o(t.classNames.labelWrapper, e.wrapper),
    onClick: function onClick(l) {
      return l.stopPropagation();
    },
    children: [s.jsx("input", {
      className: o(e.input, _defineProperty({}, e.inputSkipFocus, i)),
      type: "checkbox",
      checked: !!(d || a),
      tabIndex: i ? -1 : void 0,
      id: m,
      onChange: y,
      disabled: h
    }), s.jsxs(f.Body2, {
      as: "div",
      className: o(t.classNames.label, e.label, _defineProperty(_defineProperty(_defineProperty({}, e.pinchToTop, k), e.labelExpandedClickArea, x), e.roundedLabel, b === "circle")),
      children: [s.jsx(c, {
        icon: c.icons.system.xs.glyphs.dash,
        color: p.gray1,
        size: 12,
        className: o("checkboxIcon", _defineProperty({}, e.hidden, !a)),
        as: "i"
      }, "indeterminated"), s.jsx(c, {
        className: o("checkboxIcon", _defineProperty({}, e.hidden, a)),
        icon: c.icons.system.xs.glyphs.tick,
        color: p.gray1,
        size: 12,
        as: "i"
      }, "check"), n]
    })]
  });
};
export { z as Checkbox };